import React, { useState, useEffect } from "react";

const BACKEND_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

export function GoogleAuthButton({ disabled = false }) {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/v1/auth/config`)
      .then(r => r.json())
      .then(d => setAvailable(!!d.googleAuth))
      .catch(() => {
        // Fall back to /api/auth/config for backwards compat
        fetch(`${BACKEND_URL}/api/auth/config`)
          .then(r => r.json())
          .then(d => setAvailable(!!d.googleAuth))
          .catch(() => setAvailable(false));
      });
  }, []);

  const handleGoogleLogin = () => {
    window.location.href = `${BACKEND_URL}/api/v1/auth/google`;
  };

  if (!available) return null;

  return (
    <div>
      <button
        onClick={handleGoogleLogin}
        disabled={disabled}
        style={{
          width: "100%",
          background: "#ffffff",
          border: "1px solid #334155",
          borderRadius: 12,
          padding: "13px 16px",
          color: "#0f172a",
          fontSize: 14,
          fontWeight: 700,
          cursor: disabled ? "default" : "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 10,
          transition: "all 0.2s",
          fontFamily: "Georgia, serif",
          opacity: disabled ? 0.6 : 1,
        }}
        onMouseEnter={e => !disabled && (e.currentTarget.style.background = "#f1f5f9")}
        onMouseLeave={e => (e.currentTarget.style.background = "#ffffff")}
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285F4"/>
          <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
          <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
          <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
        </svg>
        Continue with Google
      </button>
      <p style={{ textAlign: "center", fontSize: 11, color: "#475569", marginTop: 8, marginBottom: 0 }}>
        Only @alphamedia.co.zw accounts are permitted
      </p>
    </div>
  );
}
